// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RoadType {
  Motorway = "MOTORWAY",
  FirstClassRoad = "FIRST_CLASS_ROAD",
}
export default RoadType;
